import { render, staticRenderFns } from "./CorpusAnnotationTicketList.vue?vue&type=template&id=6ca37a10&scoped=true&"
import script from "./CorpusAnnotationTicketList.vue?vue&type=script&lang=ts&"
export * from "./CorpusAnnotationTicketList.vue?vue&type=script&lang=ts&"
import style0 from "./CorpusAnnotationTicketList.vue?vue&type=style&index=0&id=6ca37a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca37a10",
  null
  
)

export default component.exports